<div class="select-search">
  <ion-input
    [label]="label"
    label-placement="floating"
    fill="outline"
    mode="md"
    [placeholder]="placeholder"
    [disabled]="disabled"
    [required]="required"
    [class.select-search__input--invalid]="required && !hasSelection"
    [value]="searchTerm"
    autocomplete="off"
    (ionInput)="onInput($any($event))"
    (ionFocus)="onFocus()"
    (ionBlur)="onBlur()"
    (keydown)="onKeyDown($event)"
  >
    @if (clearable && searchTerm) {
    <ion-button
      slot="end"
      fill="clear"
      size="small"
      [attr.aria-label]="'select.clear' | translate"
      (click)="clear()"
    >
      <ion-icon slot="icon-only" name="close-circle-outline"></ion-icon>
    </ion-button>
    }
    <ion-button
      slot="end"
      fill="clear"
      size="small"
      [attr.aria-label]="(isOpen ? 'select.hideOptions' : 'select.showOptions') | translate"
      (pointerdown)="preventInputFocus($event)"
      (click)="toggleOptions($event)"
    >
      <ion-icon
        slot="icon-only"
        [name]="isOpen ? 'chevron-up-outline' : 'chevron-down-outline'"
        aria-hidden="true"
      ></ion-icon>
    </ion-button>
  </ion-input>

  @if (isOpen && !disabled) {
  <ion-list class="select-search__options" lines="none">
    @for (item of filteredItems; track item.value; let i = $index) {
    <ion-item
      button
      detail="false"
      [disabled]="item.disabled"
      [class.highlighted]="i === highlightedIndex"
      [class.selected]="isSelected(item)"
      (click)="select(item)"
      (mouseenter)="highlightedIndex = i"
    >
      <ion-label>{{ item.label }}</ion-label>
      @if (isSelected(item)) {
      <ion-icon slot="end" name="checkmark-outline"></ion-icon>
      }
    </ion-item>
    } @empty { @if (!allowCustom || !searchTerm.trim()) {
    <ion-item class="select-search__empty" detail="false">
      <ion-label>{{ noResultsText }}</ion-label>
    </ion-item>
    } }
    <!--@if (allowCustom && searchTerm.trim() && !hasExactMatch) {
    <ion-item button detail="false" (click)="selectCustomValue()">
      <ion-label>
        {{ "select.useCustomValue" | translate : { value: searchTerm.trim() } }}
      </ion-label>
    </ion-item>
    }-->
  </ion-list>
  }
</div>
